import React, { useState, useEffect, useRef } from 'react';
import section5Video from './section5.mp4';
import './Section5.css';

const Section5 = () => {
  const [textFadeProgress, setTextFadeProgress] = useState(0);
  const [videoFadeProgress, setVideoFadeProgress] = useState(1);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Text + Video fade in as section enters (rect.top: viewportHeight -> 0)
      if (rect.top > 0) {
        const progress = Math.max(0, Math.min(1, 1 - (rect.top / viewportHeight)));
        setTextFadeProgress(progress);
        setVideoFadeProgress(progress);
      }
      // Video fades out as section exits (rect.top: 0 -> -viewportHeight)
      else if (rect.top <= 0 && rect.top > -viewportHeight) {
        setTextFadeProgress(1);
        const progress = 1 + (rect.top / viewportHeight);
        setVideoFadeProgress(Math.max(0, Math.min(1, progress)));
      }
      // Section completely scrolled past
      else {
        setTextFadeProgress(1);
        setVideoFadeProgress(0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleVideoReady = () => {
    setIsVideoLoading(false);
  };

  // Start video autoplay when component mounts
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, []);

  return (
    <section className="section5-container" ref={containerRef}>
      <div className="section5-content">

        {/* Left Side: Text Content */}
        <div className="section5-left">
          <div
            className="section5-text-wrapper"
            style={{
              opacity: textFadeProgress
            }}
          >
            <h2 className="section5-title">Program, Statistics and Height</h2>
            <p className="section5-body">
            Adjust core building properties, such as spatial programs and floor heights. Our system continuously tracks all underlying statistics and instantly synchronizes your inputs, maintaining global consistency across the entire project.
            </p>
          </div>
        </div>

        {/* Right Side: Video */}
        <div className="section5-right">
          <video
            ref={videoRef}
            className="section5-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            onLoadedData={handleVideoReady}
            onCanPlay={handleVideoReady}
            onError={handleVideoReady}
            src={section5Video}
            style={{
              opacity: videoFadeProgress
            }}
          />
          {isVideoLoading && (
            <div className="section5-video-loader" aria-live="polite">
              <div className="section5-video-spinner" />
              <span className="section5-video-loader-text">Loading demo...</span>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};

export default Section5;
